// pages/sections/NlcRequestedBadge.js
// "NLC requested" marker for a row whose No Longer Client request is waiting on the client's Partner
// (row.nlcRequest = { id, requestedBy, requestedAt, mine }), in place of the NLC switch.
// The requester (`mine`) gets a Withdraw link; the Partner decides on Home (NlcRequestsPanel).

import { useState } from 'react';
import './Disengagement.css';

export default function NlcRequestedBadge({ request, onWithdraw }) {
  const [busy, setBusy] = useState(false);
  if (!request) return null;
  const when = request.requestedAt ? new Date(request.requestedAt).toLocaleString() : '';
  const tip = `${request.mine ? 'You' : (request.requestedBy || 'Someone')} requested No Longer Client`
    + `${when ? ` on ${when}` : ''}. The client's Partner must confirm it; the client stays in every section until then.`;

  async function withdraw() {
    if (busy) return;
    setBusy(true);
    try { await onWithdraw?.(request); } finally { setBusy(false); }
  }

  return (
    <span className="nlcreq">
      <span className="nlcreq-badge" title={tip}>NLC requested</span>
      {request.mine && onWithdraw && (
        <button type="button" className="nlcreq-withdraw" disabled={busy} onClick={withdraw}
                title="Take this request back — the client stays as it is.">
          {busy ? 'Withdrawing…' : 'Withdraw'}
        </button>
      )}
    </span>
  );
}
